import { ReCAPTCHAKeysV3 } from '@src/utils/keys';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const RecaptchaContextProvider = ({ children }) => {
  return <GoogleReCaptchaProvider
    reCaptchaKey={ReCAPTCHAKeysV3}
    scriptProps={{ async: true, defer: true }}
    container={{
      element: 'captcha-render-dom',
      parameters: {
        badge: 'bottomleft',
      },
    }}
  >
    {children}
  </GoogleReCaptchaProvider>;
};

